import { Component } from '@angular/core';
import { AbstractAdvancedInput } from '../abstract-advanced-input';

@Component({
  template: `<miq-select
    [(currentValue)]="value"
    [values]="configuration.values"
    [column]="configuration"
    [required]="configuration.required"
    [disabled]="configuration.isDisabled"
    (blur)="blur($event)"
  >
  </miq-select> `,
  standalone: false,
})
export class AdvancedSelectInputComponent extends AbstractAdvancedInput {
  public blur(_e: FocusEvent): void {
    if (this.configuration.alwaysEmitChanges) this.currentValueChange.emit(this.value);
  }
}
